import { render, staticRenderFns } from "./ChangeRecoverDataPassword.vue?vue&type=template&id=7196b18e&"
import script from "./ChangeRecoverDataPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeRecoverDataPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports